import axios, { type AxiosResponse } from "axios";
import { MasterLicenseAgreementItemSchema } from "@/schemas/index";
import type { MasterLicenseAgreementItemType } from "@/schemas/index";
import env from "@/app/config/env";

export interface ServiceMasterLicenseAgreementApiType {
  fetchItem: () => Promise<MasterLicenseAgreementItemType>;
  fetchStatus: () => Promise<boolean>;
  fetchAccept: () => Promise<boolean>;
  fetchSendEmail: () => Promise<boolean>;
}

export const serviceMasterLicenseAgreementApi: ServiceMasterLicenseAgreementApiType =
  {
    fetchItem: () => {
      return axios
        .get(`${env.services.portal}/mla`)
        .then((response: AxiosResponse<unknown>) => {
          return MasterLicenseAgreementItemSchema.parse(response.data);
        });
    },
    fetchStatus: () => {
      return axios
        .get(`${env.services.portal}/mla/status`)
        .then((response: AxiosResponse<unknown>) => {
          return !!response.data;
        })
        .catch(() => {
          return true;
        });
    },
    fetchAccept: () => {
      return axios
        .post(`${env.services.portal}/mla`)
        .then(() => {
          return true;
        })
        .catch(() => {
          return false;
        });
    },
    fetchSendEmail: () => {
      return axios
        .post(`${env.services.portal}/mla/send`)
        .then(() => {
          return true;
        })
        .catch(() => {
          return false;
        });
    },
  };
